import React from 'react';
import ReviewItemCard from './ReviewItemCard';

const ExerciseCard = ({id, title, selected, onToggle, chips, previewButton, onPreview}) => (
    <ReviewItemCard
        id={id}
        text={title}
        checked={selected}
        onToggle={onToggle}
        tags={chips}
        onPreview={previewButton ? onPreview : undefined}
    />
);

export default ExerciseCard;
